import { config } from "@/configs/appConfig";

const defaultState = () => ({
  pendingVerifications: [],
  ringing: false,
  appLoading: false,
  appLoadingError: false,
  activeLead: {},
  agents: [],
  liveCalls: [],
  currentTask: {},
  callConnected: false,
  inCallMode: false,
  inAdminCallMode: false,
  taskAttributes: {},
  user: {},
  productOptions: [],
  upcomingCallbacks: [],
  enqueuedCalls: [],
  access: {
    dataAccess: {},
    featureAccess: {}
  },
  config
});

export default defaultState;
